import ButtonRoundContainer from "../../components/ButtonRoundContainer/ButtonRoundContainer";
import { useParams } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import NeedsContainer from "../../components/NeedsContainer/NeedsContainer";
import PhonicComponent from "../../components/PhonicComponent/PhonicComponent";
import "./BlendingGame.scss";
import AnimatedImage from "../../components/AnimatedImage/AnimatedImage";
import BlendingGameCharacter from "../../assets/images/BlendingGameCharacter.png";
import useTimer from "../../hooks/useTimer";
import { useContext, useEffect, useState } from "react";
import UserContext from "../../context/UserContext";
import {
  getArrayForGame,
  getPhonemeArray,
  updateUserStats,
  getLevelData,
} from "../../utils/gameUtils";
import GameEnd from "../../components/GameEnd/GameEnd";

const BlendingGamePage = () => {
  const { level } = useParams();
  const [gameState, setGameState] = useState({
    score: 0,
    index: 0,
    isCorrect: false,
  });

  const [wordsArray, setWordsArray] = useState([]);
  const [isGameOver, setIsGameOver] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [phonicHighlighted, setPhonicHighlighted] = useState(0);

  const { user, getRounds, setUser } = useContext(UserContext);
  const [isFinished, counter] = useTimer(999999999);

  useEffect(() => {
    if (counter % 6 == 0 && !isFinished) {
      updateUserStats("energy", user, setUser);
    }
  }, [counter]);

  // load up the words array
  useEffect(async () => {
    if (!user?.uid) return;
    const array = await getArrayForGame(
      parseInt(level), //level
      "blending",
      getRounds("blending", false), //#incorrect rounds
      getRounds("blending", true), //#correct rounds
      3 //max correct per game
    );

    setWordsArray(array);
    setIsLoaded(true);
  }, [user?.uid]);

  const handleAnswer = async (isCorrect) => {
    if (isCorrect) {
      updateUserStats("fuel", user, setUser);
    }

    const score = gameState.score + (isCorrect ? 1 : 0);
    const index = handleIndexChange();

    setGameState({
      score,
      isCorrect,
      index,
    });
  };

  const handleIndexChange = () => {
    if (gameState.index == wordsArray.length - 1) {
      handleGameEnd();
    } else {
      setPhonicHighlighted(0);
      return gameState.index + 1;
    }
  };

  const handleGameEnd = () => {
    setIsGameOver(true);
  };

  if (!isLoaded) {
    return (
      <Layout requiresAuth={true}>
        <div className="blending-game">
          <p>Loading...</p>
        </div>
      </Layout>
    );
  }

  if (isGameOver) {
    return (
      <Layout requiresAuth={true}>
        <div className="blending-game">
          <GameEnd
            score={gameState.score}
            childName={user.childName}
            energyLevel={user.energyLevel}
            gameType={"Blending Game"}
          />
        </div>
      </Layout>
    );
  }

  if (user.energyLevel == 0) {
    return (
      <Layout requiresAuth={true}>
        <div className="blending-game">
          <GameEnd
            score={gameState.score}
            childName={user.childName}
            energyLevel={user.energyLevel}
          />
        </div>
      </Layout>
    );
  }

  return (
    <Layout requiresAuth={true}>
      <div className="blending-game">
        <div className="blending-game__needs-container">
          <NeedsContainer />
        </div>
        <div className="blending-game__phonic">
          <p className="blending-game__score">
            Number Of Correct Words: {gameState.score}
          </p>
          <PhonicComponent
            phonicArray={getPhonemeArray(
              wordsArray[gameState.index],
              getLevelData(level)
            )}
            phonicHighlighted={phonicHighlighted}
            setPhonicHighlighted={setPhonicHighlighted}
          />
        </div>
        <div className="blending-game__character">
          <AnimatedImage imageToAnimate={BlendingGameCharacter} />
        </div>
        <ButtonRoundContainer
          handleCorrect={() => handleAnswer(true)}
          handleIncorrect={() => handleAnswer(false)}
        />
      </div>
    </Layout>
  );
};

export default BlendingGamePage;
